package floris.graphics.core.navigation

import floris.graphics.core.Constants


sealed class Navigation(val route: String) {

    sealed class Screen(route: String) : Navigation(route) {

        sealed class Admin(route: String) : Screen("/admin$route") {
            data object Home : Admin("/")
            data object Login : Admin(route = "/login")

            sealed class Categories(route: String) : Admin("/categories$route") {
                data object Index : Categories("")
                data class Manage(val id: String? = null) : Categories("/manage" + if (id != null) "?id=$id" else "")
            }

            sealed class Techstacks(route: String) : Admin("/techstacks$route") {
//                fun searchByTitle(query: String) = "/techstacks?$QUERY_PARAM=$query"

                data object Index : Techstacks("")
                data class Manage(val id: String? = null) : Techstacks("/manage" + if (id != null) "?id=$id" else "")
            }

            sealed class Contributors(route: String) : Admin("/contributors$route") {
                data object Index : Contributors("")
                data class Manage(val id: String? = null) : Contributors("/manage" + if (id != null) "?id=$id" else "")
            }

            sealed class Projects(route: String) : Admin("/projects$route") {
//                fun searchByTitle(query: String) = "/projects?$QUERY_PARAM=$query"

                data object Index : Projects("")
                data class Manage(val id: String? = null) : Projects("/manage" + if (id != null) "?id=$id" else "")
            }

            data object Settings : Admin("/settings")
        }

        data object Home : Screen("/") {
            val contactFragment get() = "#contact"
            fun categorySelection(categoryId: String?) = if (categoryId != null) "/?${Constants.CATEGORY_ID}=$categoryId" else route
        }

        data object Project : Screen("/project") {
            fun getProject(id: String) = "/project/?projectId=$id"
        }
    }

    sealed class External(route: String) : Navigation(route) {

        data object Instagram : Navigation("https://www.instagram.com/thijs.floris")
        data object LinkedIn : Navigation("https://www.linkedin.com/in/floris-thijs-b5584875/")
        data object Youtube : Navigation("https://www.youtube.be/")
        data class Maps(val query: String) : Navigation("http://maps.google.com/maps?q=$query")
        data class Mail(val email: String) : Navigation("mailto:$email")
        data class Phone(val number: String) : Navigation("tel:$number")
    }
}
